export const PARSED_USER_EMAIL = {
    userEmail: '',
};

export const SURVEY_LINK =
    'https://printinsights.qualtrics.com/jfe/form/SV_a4M1CSNhU6HHOmy';
